import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

/** Mirrors the new route's schema so `publish` survives the redirect. */
const searchSchema = z.object({
  publish: z.coerce.string().optional(),
});

/**
 * Moved to /audiolab/releases/$ALBUM_ID. Kept as a redirect so existing
 * bookmarks and links out in the wild still land somewhere real.
 */
export const Route = createFileRoute("/audiolab/albums/$ALBUM_ID")({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/audiolab/releases/$ALBUM_ID",
      params,
      search,
      replace: true,
    });
  },
});
